export default __webpack_public_path__ + "static/media/mobile_about_cover.347a61b0.jpeg";